import {AxiosInstance} from "axios";
import {createOne, deleteOne, queryPage, updateOne} from "../../../shared/technical/rest/restApi";
import {License} from "./License";
import {fullPageable, PagedResult} from "../../../shared/technical/rest/pageable";

export function getAllLicenses(axios: AxiosInstance, applicationId: string | number): Promise<License[]> {
  return queryPage<License>(axios, "applications/" + applicationId + "/licenses", fullPageable())
    .then((page: PagedResult<License>) => page.content.map((license: any) => {
      // TODO: remove this hack when compatibility for old version is not needed anymore
      license["key"] = undefined;
      license["name"] = undefined;
      license["allowedUris"] = undefined;
      return license;
    }))
}

export function createLicense(axios: AxiosInstance, applicationId: string | number, license: License): Promise<License> {
  return createOne(axios, "applications/" + applicationId + "/licenses", license)
}

export function updateLicense(axios: AxiosInstance, applicationId: string | number, license: License): Promise<License> {
  return updateOne(axios, "applications/" + applicationId + "/licenses", license)
}

export function deleteLicense(axios: AxiosInstance, applicationId: string | number, licenseId: string | number): Promise<void> {
  return deleteOne(axios, "applications/" + applicationId + "/licenses", licenseId)
}
